import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";

/**
 * Custom Formly field type for Google Places location autocomplete.
 */
@Component({
  selector: "formly-location-autocomplete",
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    NgxGpAutocompleteModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mb-3">
      @if (props.label) {
        <h5 class="font-alternate text-sm font-semibold text-black tracking-tight mb-1.5">
          {{ props.label | translate }}
        </h5>
      }
      <div class="flex rounded border border-gray-200 overflow-hidden focus-within:ring-1 focus-within:ring-mty-primary focus-within:border-mty-primary transition-shadow">
        <span class="inline-flex items-center px-2.5 text-gray-400 bg-gray-50 border-r border-gray-200">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        </span>
        <input
          type="text"
          class="flex-1 min-w-0 px-3 py-1.5 text-sm border-0 outline-none bg-white"
          ngx-gp-autocomplete
          #placesRef="ngx-places"
          [placeholder]="props.placeholder || 'Location' | translate"
          [value]="formControl.value || ''"
          (onAddressChange)="onAddressChange($event)"
          (input)="onInputChange($any($event.target).value)"
        />
      </div>
    </div>
  `,
})
export class LocationAutocompleteFieldType extends FieldType<FieldTypeConfig> {
  onAddressChange(event: any): void {
    if (event?.address_components?.length) {
      this.formControl.setValue(event.address_components[0].short_name);

      if (event.geometry?.location && this.props["onCoordinatesChange"]) {
        const lat =
          typeof event.geometry.location.lat === "function"
            ? event.geometry.location.lat()
            : event.geometry.location.lat;
        const lng =
          typeof event.geometry.location.lng === "function"
            ? event.geometry.location.lng()
            : event.geometry.location.lng;
        this.props["onCoordinatesChange"]({ lat, lng });
      }
    } else if (typeof event === "string") {
      this.formControl.setValue(event);
    }
  }

  onInputChange(value: string): void {
    this.formControl.setValue(value);

    if (!value && this.props["onCoordinatesChange"]) {
      this.props["onCoordinatesChange"](null);
    }
  }
}
